import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IContactLoggedInDto } from './models/contact-logged-in-dto';
import { PLATFORM, Platform, SERVICES_API } from '@pro-connect/shared';
import { IContactNotLoggedInDto } from './models/contact-not-logged-in-dto';
import { IContactSubject } from './models/contact-subject';

@Injectable({
  providedIn: 'root',
})
export class ContactService {
  constructor(
    @Inject(SERVICES_API)
    private readonly _servicesApi: string,
    @Inject(PLATFORM)
    private readonly _platform: Platform,
    private readonly _httpClient: HttpClient,
  ) {}

  /**
   * Submit a message from contact form
   * @param dto
   */
  public submitContactMessageLoggedIn(dto: IContactLoggedInDto): Observable<unknown> {
    return this._httpClient.post<unknown>(`${this._servicesApi}/pro/client/contact/message/submit`, dto, {
      withCredentials: true,
    });
  }

  /**
   * Get a list of contact subjects
   */
  public getContactSubjects(): Observable<IContactSubject[]> {
    return this._httpClient.get<IContactSubject[]>(`${this._servicesApi}/pro/contact/subject/list`);
  }

  /**
   * Submit a message from contact form
   * @param dto
   * @param recaptchaKey
   */
  public submitContactMessageNotLoggedIn(dto: IContactNotLoggedInDto, recaptchaKey: string): Observable<unknown> {
    return this._httpClient.post<unknown>(`${this._servicesApi}/pro/contact/message/${this._platform}/submit`, dto, {
      params: {
        recaptchaKey,
      },
    });
  }
}
